import React from 'react'

export default () => (
  <svg width="313px" height="221px" viewBox="0 0 313 221">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="SideBySide" transform="translate(-353.000000, -136.000000)">
        <g id="Group" transform="translate(353.000000, 136.000000)">
          <rect id="Rectangle" stroke="#AAAAAA" fill="#FFFFFF" x="0.5" y="0.5" width="144" height="220" rx="2" />
          <rect id="Rectangle-Copy" stroke="#209216" fill="#FFFFFF" x="164.5" y="0.5" width="148" height="220" rx="2" />
          <text id="Your-Assessment" fontFamily="'Open Sans'" fontSize="12" fontWeight="bold" line-spacing="18" fill="#111111">
            <tspan x="9" y="19">
              Your Assessment{' '}
            </tspan>
          </text>
          <text id="The-Dealer’s-Review" fontFamily="'Open Sans'" fontSize="12" fontWeight="bold" line-spacing="18" fill="#111111">
            <tspan x="178" y="19">
              Dealer Assessment{' '}
            </tspan>
          </text>
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 60.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L63,1" id="Hard-Divider" />
          </g>
          <rect id="Rectangle" fill="#209216" x="195" y="56" width="72" height="8" />
          <rect id="Rectangle-Copy-4" fill="#9B9B9B" x="178" y="44" width="121" height="1" />
          <rect id="Rectangle-Copy-5" fill="#9B9B9B" x="12" y="44" width="121" height="1" />
          <rect id="Rectangle-Copy-2" fill="#209216" x="195" y="101" width="104" height="8" />
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 81.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L121,1" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(178.000000, 81.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L121,1" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 103.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1.5 L100,1.5" id="Hard-Divider" />
          </g>
          <image id="u563" x="178" y="54" width="13" height="13" />
          <image id="u563-copy-3" x="178" y="26" width="13" height="13" />
          <image id="u563-copy" x="178" y="99" width="13" height="13" />
          <text id="Updates" fontFamily="'Open Sans'" fontSize="10" fontWeight="bold" line-spacing="15" fill="#229717">
            <tspan x="195" y="35">
              Updates
            </tspan>
          </text>
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 126.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L121,1" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(178.000000, 126.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L121,1" id="Hard-Divider" />
          </g>
          <rect id="Rectangle-Copy-3" fill="#209216" x="195" y="166" width="104" height="8" />
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 148.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L63,1" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(178.000000, 148.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L63,1" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 169.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1 L121,1" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(12.000000, 191.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1.5 L100,1.5" id="Hard-Divider" />
          </g>
          <g id="UI-Element/Divider/Hard" transform="translate(178.000000, 191.000000)" stroke="#979797" strokeWidth="8">
            <path d="M0,1.5 L100,1.5" id="Hard-Divider" />
          </g>
          <image id="u563-copy-2" x="178" y="164" width="13" height="13" />
        </g>
      </g>
    </g>
  </svg>
)
